/**
 * 방화벽 보안 프로파일 store
 * Ipv4, Ipv6
 *
 * @since 2018-06-09
 * @author kdydesign.kim
 */
// TAMS
import {ObjectSecProfileApiPrefix as opApiPrefix, CmApiPrefix as cmApiPrefix} from 'utils'

// 임시 store -> security_profile로 바꿔야함
export const state = () => ({
  fileTypeProfile: [],
  dlpProfile: [],
  antiVirusProfile: [],
  antiSpamProfile: [],
  webFilterProfile: [],
  aptProfile: [],
  ipsProfile: []
})

export const mutations = {
  // store 초기화
  clearSecProfileStore (state) {
    state.fileTypeProfile = []
    state.dlpProfile = []
    state.antiVirusProfile = []
    state.antiSpamProfile = []
    state.webFilterProfile = []
    state.aptProfile = []
    state.ipsProfile = []
  },

  // 프로파일 조회
  getProfileData (state, {result, context}) {
    let profileKey = void 0

    switch (context) {
      case 'filetype':
        profileKey = 'fileTypeProfile'
        break
      case 'dlp':
        profileKey = 'dlpProfile'
        break
      case 'av':
        profileKey = 'antiVirusProfile'
        break
      case 'as':
        profileKey = 'antiSpamProfile'
        break
      case 'wf':
        profileKey = 'webFilterProfile'
        break
      case 'apt':
        profileKey = 'aptProfile'
        break
      case 'ips':
        profileKey = 'ipsProfile'
        break
      default:
        break
    }

    state[profileKey] = Object.freeze(result)
  },

  // 프로파일 목록 초기화
  resetProfileList (state) {
    state.fileTypeProfile = []
    state.dlpProfile = []
    state.antiVirusProfile = []
    state.antiSpamProfile = []
    state.webFilterProfile = []
    state.aptProfile = []
    state.ipsProfile = []
  }
}

export const actions = {
  // 프로파일 조회
  async getProfileData ({commit, state}, {context}) {
    const {code, result} = await this.$axios.$get(`${opApiPrefix}/${context}/profiles`)

    if (code === 'ok') {
      commit('getProfileData', {result, context})
    }
  },
  async setFwRuleProfile ({commit, state}, {fwRuleId, fwRulePrfType, fwRulePrfId} = {}) {
    const params = {
      fw_rule_prf_type: fwRulePrfType,
      fw_rule_prf_id: fwRulePrfId
    }
    const res = await this.$axios.$post(`${cmApiPrefix}/fw-rule/profile/${fwRuleId}`, params, {
      // loading: false,
      successAlert: false
    })
    return res
  }
}

export const getters = {
  // ips 프로파일 select box 데이터
  ipsProfileToSelectBox (state) {
    const result = _.map(state.ipsProfile, (o) => {
      return {
        // TAMS (name -> ips_prf_uname)
        label: o.ips_prf_uname,
        value: o.ips_prf_id
      }
    })

    result.unshift({
      label: 'None',
      value: void 0
    })

    return Object.freeze(result)
  },

  // 웹 필터 프로파일 select box 데이터
  webFilterProfileToSelectBox (state) {
    const result = _.map(state.webFilterProfile, (o) => {
      return {
        // TAMS (name -> wf_prf_uname)
        label: o.wf_prf_uname,
        value: o.wf_prf_id
      }
    })

    result.unshift({
      label: 'None',
      value: void 0
    })

    return Object.freeze(result)
  },

  // DLP 프로파일 select box 데이터
  dlpProfileToSelectBox (state) {
    const result = _.map(state.dlpProfile, (o) => {
      return {
        // TAMS (name -> dlp_prf_uname)
        label: o.dlp_prf_uname,
        value: o.dlp_prf_id
      }
    })

    result.unshift({
      label: 'None',
      value: void 0
    })

    return Object.freeze(result)
  },

  // 안티 바이러스 프로파일 select box 데이터
  antiVirusProfileToSelectBox (state) {
    const result = _.map(state.antiVirusProfile, (o) => {
      return {
        // TAMS (name -> av_prf_uname)
        label: o.av_prf_uname,
        value: o.av_prf_id
      }
    })

    result.unshift({
      label: 'None',
      value: void 0
    })

    return Object.freeze(result)
  },

  // 안티 스팸 프로파일 select box 데이터
  antiSpamProfileToSelectBox (state) {
    const result = _.map(state.antiSpamProfile, (o) => {
      return {
        // TAMS (name -> as_prf_uname)
        label: o.as_prf_uname,
        value: o.as_prf_id
      }
    })

    result.unshift({
      label: 'None',
      value: void 0
    })

    return Object.freeze(result)
  },

  // 파일 유형 제어 프로파일 select box 데이터
  fileTypeProfileToSelectBox (state) {
    const result = _.map(state.fileTypeProfile, (o) => {
      return {
        // TAMS (name -> file_type_ctrl_prf_uname)
        label: o.file_type_ctrl_prf_uname,
        value: o.file_type_ctrl_prf_id
      }
    })

    result.unshift({
      label: 'None',
      value: void 0
    })

    return Object.freeze(result)
  },

  // APT 프로파일 select box 데이터
  AptProfileToSelectBox (state) {
    const result = _.map(state.aptProfile, (o) => {
      return {
        // TAMS (name -> apt_prf_uname)
        label: o.apt_prf_uname,
        value: o.apt_prf_id
      }
    })

    result.unshift({
      label: 'None',
      value: void 0
    })

    return Object.freeze(result)
  }

}

export const strict = false
